import { fadeIn, fadeOut } from "../../utils/fade"
import { defaultTabsOptions } from "./tabs.options"

export class Tabs {
  constructor(options) {
    this.options = { ...defaultTabsOptions, ...options }

    this.$container =
      this.options.container instanceof HTMLElement
        ? this.options.container
        : document.querySelector(this.options.container)

    if (!this.$container) {
      return
    }

    this.isLocked = false
    this.duration = this.options.duration / 2

    this.activeIndex = typeof this.options.activeIndex === "number" ? this.options.activeIndex : 0

    this.triggers = this.$container.querySelectorAll(this.options.itemTriggerSelector)
    this.items = this.$container.querySelectorAll(this.options.itemContentSelector)

    this.displayType = this.options.display || "flex"

    this.currentItem = null
    this.currentTrigger = null

    if (this.triggers.length === 0 || this.items.length === 0) return

    this.#init()
  }

  #init() {
    this.items.forEach((item) => {
      item.style.display = "none"
      item.classList.remove(this.options.activeClass)
    })

    this.triggers.forEach((btn) => btn.classList.remove(this.options.activeClass))

    let startIndex = this.activeIndex
    if (!this.items[startIndex]) {
      console.warn(`Tabs: Index ${startIndex} not found via init. Fallback to 0.`)
      startIndex = 0
    }

    const startItem = this.items[startIndex]
    if (startItem) {
      this.currentItem = startItem
      this.currentItem.style.display = this.displayType
      this.currentItem.classList.add(this.options.activeClass)
      this.changeActiveButton()
    }

    this.triggers.forEach(($button) => {
      const tabTargetID = $button.dataset.tabId

      $button.addEventListener("click", (e) => {
        if ($button.tagName === "A") e.preventDefault()

        if (tabTargetID) {
          this.setNewTabByID(tabTargetID)
        }
      })
    })
  }

  #changeTab($newItem) {
    if (this.currentItem === $newItem) {
      this.isLocked = false
      return
    }

    this.isLocked = true

    if (this.currentItem) {
      fadeOut(this.currentItem, this.duration, () => {
        this.currentItem.classList.remove(this.options.activeClass)
        this.currentItem = $newItem

        fadeIn(
          this.currentItem,
          this.duration,
          () => {
            this.currentItem.classList.add(this.options.activeClass)
            this.changeActiveButton()
            this.isLocked = false
          },
          this.displayType,
        )
      })
    } else {
      this.currentItem = $newItem
      fadeIn(
        this.currentItem,
        this.duration,
        () => {
          this.currentItem.classList.add(this.options.activeClass)
          this.changeActiveButton()
          this.isLocked = false
        },
        this.displayType,
      )
    }
  }

  setNewTabByID(id) {
    if (this.isLocked) return

    const $newItem = [...this.items].find(($item) => $item.id == id)

    if ($newItem) {
      this.#changeTab($newItem)
    } else {
      console.warn(`Tab content with ID "${id}" not found`)
      this.isLocked = false
    }
  }

  setNewTabByIndex(index) {
    if (this.isLocked) return
    const $newItem = this.items[index]
    if ($newItem) {
      this.#changeTab($newItem)
    }
  }

  changeActiveButton() {
    if (!this.currentItem) return
    const currentID = this.currentItem.id

    this.triggers.forEach(($button) => {
      if ($button.dataset.tabId == currentID) {
        $button.classList.add(this.options.activeClass)
      } else {
        $button.classList.remove(this.options.activeClass)
      }
    })
  }
}
